import React from 'react';
import flagImage from '../../../assets/icons/flag-alt.png';
import {
  AccordionCollpaseContent,
  QuarterHeaderCollapseTitle,
} from '../../../atoms/sidebar/sidebar.styles';
import Legend from './legend';

function QuarterlyCollapsedSidebar(props) {
  let legendData;
  let data = props?.data;
  let quarter = props?.quarter;
  let quarterTitle = props?.quarterTitle;

  quarterTitle == 'BEYOND'
    ? (legendData = data['months'][0].calculation)
    : (legendData = data['quarterlyCalculation']);

  return (
    <>
      <QuarterHeaderCollapseTitle>{quarterTitle}</QuarterHeaderCollapseTitle>
      <AccordionCollpaseContent>
        <Legend
          quarterlyData={legendData}
          quarterText={quarter}
          flagImageSrc={flagImage}
          quarterTitle={quarterTitle}
        />
      </AccordionCollpaseContent>
    </>
  );
}

export default QuarterlyCollapsedSidebar;
